var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card-detail" }, [
    _c(
      "div",
      [
        _c(
          "a-page-header",
          { staticClass: "page-header", on: { back: _vm.back } },
          [
            _c(
              "div",
              {
                staticStyle: { cursor: "pointer" },
                attrs: { slot: "title" },
                on: { click: _vm.back },
                slot: "title",
              },
              [
                _vm._v("\n        返回 班级管理/\n        "),
                _c("span", { staticStyle: { color: "#297ede" } }, [
                  _vm._v(_vm._s(_vm.cardObj.title)),
                ]),
              ]
            ),
          ]
        ),
        _c("a-divider", { staticStyle: { margin: "0" } }),
      ],
      1
    ),
    _c(
      "div",
      { staticStyle: { padding: "0 40px" } },
      [
        _c(
          "div",
          { staticStyle: { margin: "15px 0" } },
          [
            _c(
              "div",
              {
                staticClass: "title-1",
                staticStyle: { "margin-bottom": "20px" },
              },
              [_vm._v(_vm._s(_vm.cardObj.title))]
            ),
            _vm.cardObj?.wordFile ||
            _vm.cardObj?.file?.includes(".doc") ||
            _vm.cardObj?.file?.includes(".docx")
              ? _c(
                  "a-button",
                  {
                    staticStyle: { "margin-right": "15px" },
                    attrs: { type: "primary", icon: "download" },
                    on: {
                      click: function ($event) {
                        return _vm.downloadWord(
                          _vm.cardObj.wordFile || _vm.cardObj.file
                        )
                      },
                    },
                  },
                  [_vm._v("\n        下载主题Word文档\n      ")]
                )
              : _vm._e(),
            _vm.cardObj?.pptFile ||
            _vm.cardObj?.file?.includes(".ppt") ||
            _vm.cardObj?.file?.includes(".pptx")
              ? _c(
                  "a-button",
                  {
                    attrs: { type: "primary", icon: "download" },
                    on: {
                      click: function ($event) {
                        return _vm.downloadWord(
                          _vm.cardObj.pptFile || _vm.cardObj.file
                        )
                      },
                    },
                  },
                  [_vm._v("\n        下载PPT文档\n      ")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c("a-divider"),
        _c("div", [
          _c("div", { domProps: { innerHTML: _vm._s(_vm.cardObj.content) } }),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }